export default __webpack_public_path__ + "static/media/DividendStatement.c4d9f397.pdf";